import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import postData from '../../utilities/postData';
import PropTypes from 'prop-types';

const MiscSaleItem = ({
    item,
    fetchData,
    editItem
}) => {
    const deleteUrl = '/api/miscsales/delete/' + item.id;

    function deleteItem() {
        postData(deleteUrl, null, () => {
            fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }

    const descriptions = item.miscSaleDetails.map((detail, index) =>
        <span key={index}>{detail.description}</span>);

    return (
        <tr>
            <CustomTd content={formatter.date(item.date)} />
            <CustomTd hide="md" content={item.designerName} />
            <CustomTd hide="sm" content={formatter.currency(item.total)} />
            <CustomTd hide="lg" content={formatter.currency(item.deposit)} />
            <CustomTd hide="lg" content={formatter.currency(item.balance)} />
            <CustomTd content={item.paid} />
            <CustomTd>
                <div className="d-flex flex-column">
                    {descriptions}
                </div>
            </CustomTd>
            <CustomTd className="button-cell">
                <EditDeleteButton
                    showText={false}
                    viewItem={() => editItem(item.id)}
                    editItem={() => editItem(item.id)}
                    deleteItem={deleteItem}
                    acl={item.acl}/>
            </CustomTd>
        </tr>
    );
}

MiscSaleItem.propTypes = {
    fetchData: PropTypes.func,
    editItem: PropTypes.func,
    deleteUrl: PropTypes.string
};

export default MiscSaleItem;